import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChargingStationEntry, ElectricityMeterUnitEntry } from '../charging-stations-section.model';

export enum EmuDeletionReason {
  ChargingStationDeleted,
  ChargingStationChanged,
  AlignedToProductUpdates
}

@Component({
  selector: 'app-confirm-emu-deletion-dialog',
  templateUrl: './confirm-emu-deletion-dialog.component.html',
  styleUrls: ['./confirm-emu-deletion-dialog.component.scss']
})
export class ConfirmEmuDeletionDialogComponent implements OnInit {

  get chargingStationChanged(): boolean {
    return this.dialogData.emuDeletionReason === EmuDeletionReason.ChargingStationChanged;
  }

  get chargingStationDeleted(): boolean {
    return this.dialogData.emuDeletionReason === EmuDeletionReason.ChargingStationDeleted;
  }

  get alignedToProductUpdates(): boolean {
    return this.dialogData.emuDeletionReason === EmuDeletionReason.AlignedToProductUpdates;
  }

  constructor(private dialogRef: MatDialogRef<ConfirmEmuDeletionDialogComponent, boolean>,
              @Inject(MAT_DIALOG_DATA) public dialogData: {
                csEntry: ChargingStationEntry,
                emuEntry: ElectricityMeterUnitEntry,
                emuDeletionReason: EmuDeletionReason }) { }

  ngOnInit(): void {

  }

  public confirmDeletion(): void {
    this.dialogRef.close(true);
  }

  public cancel(): void {
    this.dialogRef.close(false);
  }
}
